export enum EnvironmentEnum {
  PREVIEW = "preview",
  DEVELOPMENT = "development",
  PRODUCTION = "production",
  TEST = "test",
}

export enum RuntimeEnum {
  CLIENT = "client",
  SERVER = "server",
  EDGE = "edge",
  UNKNOWN = "unknown",
}

export enum MethodEnum {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
}

export enum ProtocolEnum {
  HTTP = "http",
  HTTPS = "https",
}
